import { Button, Modal } from 'react-bootstrap';

const BankModal = ({ show, onClick }) => {
  const recipientEmail = 'support@ebullion.in';
  const subject = 'Regarding Bank Details Update';

  const mailtoLink = `mailto:${recipientEmail}?subject=${encodeURIComponent(
    subject
  )}`;
  return (
    <Modal
      show={show}
      aria-labelledby='contained-modal-title-vcenter'
      centered
      onHide={() => onClick()}
    >
      <Modal.Header closeButton>
        <Modal.Title id='contained-modal-title-vcenter'>NOTE</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          To edit your bank details, please reach out to us at
          <a href={mailtoLink} style={{ color: '#99834d' }}>
            {' '}
            support@ebullion.in
          </a>{' '}
          and provide the valid bank details including the Account Holder's Name
          (as per bank account), Account Number, IFSC Code, and Bank Name.
        </p>
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: 'center' }}>
        {/* <Button variant='primary' size='sm' onClick={onClick}>
          Continue
        </Button> */}
        <p style={{ fontSize: '12px' }}>
          Your details will be updated within 24 - 48 working hours upon
          receiving your request.
        </p>
      </Modal.Footer>
    </Modal>
  );
};

export default BankModal;
